import { combineReducers } from "redux";

import loginReducer from "./slices/loginSlice";
import inventoryReducer from "./slices/inventorySlice";
import financialAdvisorReducer from "./slices/financialAdvisorSlice"
import clientInfoReducer from "./slices/clientInfoSlice";
import propertiesSlice from "./slices/propertiesSlice";
import roomsSlice from "./slices/roomsSlice";
import itemsSlice from "./slices/itemsSlice";
import chatSlice from "./slices/chatSlice";
import goalFormReducer from "./slices/goalFormSlice";

export default combineReducers({
  loginUser: loginReducer,
  inventory: inventoryReducer,
  clientInfo: clientInfoReducer,
  propertiesInfo: propertiesSlice,
  roomsInfo: roomsSlice,
  itemsInfo: itemsSlice,
  chatInfo: chatSlice,
  financialAdvisor: financialAdvisorReducer,
  goalForm: goalFormReducer,
});
